import { getAllLazyControllers, getGroupControllers } from "./lazy_controllers.js"

// Extract identifier from controller path
export function identifierForContextKey(key) {
    const logicalName = (key.match(/^(?:\.\.\/controllers\/|\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1]

    if (logicalName) {
        return logicalName.replace(/_/g, "-").replace(/\//g, "--")
    }
}

// Normalize path for comparison with lazyControllers
export function normalizePath(path) {
    return path.replace(/^\.\.\/controllers\//, './').replace(/^\.\//, './')
}

// Check if controller should be lazy loaded
export function isLazyController(path) {
    const normalizedPath = normalizePath(path)
    return getAllLazyControllers().includes(normalizedPath)
}

// Check if controller belongs to a specific group
export function isInGroup(path, groupName) {
    const normalizedPath = normalizePath(path)
    return getGroupControllers(groupName).includes(normalizedPath)
}

// Register controllers based on filter
export function registerControllers(application, controllers, options = {}) {
    const { group, excludeLazy = false } = options
    
    Object.entries(controllers).forEach(([path, controllerModule]) => {
        let shouldRegister = false
        
        if (group) {
            // Load only controllers in the specified group
            shouldRegister = isInGroup(path, group)
        } else if (excludeLazy) {
            // Load all controllers except lazy ones
            shouldRegister = !isLazyController(path)
        } else {
            // Load all controllers
            shouldRegister = true
        }
        
        if (shouldRegister) {
            const identifier = identifierForContextKey(path)
            if (identifier && controllerModule.default) {
                application.register(identifier, controllerModule.default)
            }
        }
    })
}
